import { CheckCircle } from "react-feather"
import { Button } from "reactstrap"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

const ValidateConfirmation = ({ onTouch, onSuccess, children }) => {
  const confirmationModal = () => {
    const MySwal = withReactContent(Swal)
    MySwal.fire({
      title: "Confirm",
      html: (
        <p>
          Do you want to <b>validating</b> this ?
        </p>
      ),
      customClass: {
        input: "mx-3",
        cancelButton: "btn btn-light ms-1",
        confirmButton: "btn btn-success mx-1"
      },
      buttonsStyling: false,
      cancelButtonText: "Cancel",
      confirmButtonText: "Validate",
      showCancelButton: true,
      showLoaderOnConfirm: true,
      async preConfirm() {
        return await onTouch()
      }
    }).then(function (res) {
      if (res.isConfirmed) {
        console.log(res)
        if (res.value.status === 201) {
          MySwal.fire({
            position: "bottom-end",
            icon: "success",
            title: "Validated",
            showConfirmButton: false,
            timer: 1200,
            backdrop: false
          })
          onSuccess()
        } else {
          MySwal.fire({
            title: "Error",
            html: (
              <div>
                <p>An error occured while validating the item.</p>
              </div>
            ),
            icon: "error",
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
              confirmButton: "btn btn-primary"
            }
          })
        }
      }
    })
  }

  return (
    <div onClick={confirmationModal}>
      {children ? (
        children
      ) : (
        <Button color="flat-success" size="sm">
          <CheckCircle size={17} />
        </Button>
      )}
    </div>
  )
}

export default ValidateConfirmation
